export default "__VITE_PUBLIC_ASSET__b93a9b3d__"